import axios from "@/store/axiosInstance";
import delay from "@/utilities/delay";

const tempQuery = {
    _id: 2,
    deviceData: {
        deviceName: "Panele",
        serialNumber: "23234",
        installationDate: "17.03.2017",
    },
    installatorData: {
        companyName: "Firma",
        contactPerson: "Marek",
        contactNumber: "505674938",
        email: "email@.com.pl",
        address: {
            street: "Zimna",
            buildingNumber: "5/3",
            city: "Będzin",
            region: "Śląsk",
            zipCode: "50-932",
            country: "Polska",
        },
        returnAddress: {
            street: "Krzywa",
            buildingNumber: "4a",
            city: "Katowice",
            region: "Śląsk",
            zipCode: "40-719",
            country: "Polska",
        },
    },
    customerData: {
        customerName: "Karol Krawczyk",
        contactNumber: "505674938",
        email: "email@.com.pl",
    },
    specificationData: {
        specification: "20",
        vmp: "30",
        power: "100",
        pointsNumber: "2/3",
        panelsNumber: "5/5",
        voltage: "300/200/300",
    },

    issueData: {
        screen: "Error",
        ledColor: "Czerwony",
        desc:
            "Opis usterki asas adasasa asasasas asasasasas adasasa asasasas asasasasas adasasa asasasas asasasasas adasasa asasasas asasasasas adasasa asasasas asasasasas adasasa asasasas asasas",
        author: "Karol Krawczyk",
    },

    files: {
        diagram: [
            {
                name: "plik-schematu.pdf",
            },
        ],
        sketch: [
            {
                name: "plik-szkicu.pdf",
            },
        ],
        invoice: [
            {
                name: "plik-faktury.pdf",
            },
        ],
    },
    isSaved: false,
};

const secondForm = {
    namespaced: true,
    state: {
        secondForm: [],
    },
    mutations: {
        ADD_DATA_TO_STATE(state, data) {
            state.secondForm = data;
        },

        ADD_ADDITIONAL_INFO_TO_STATE(state, data) {
            //   console.log("data", data);
            state.secondForm.additionalInfo = data;
            state.secondForm.isSaved = true;
        },
    },
    actions: {
        async POPULATE_FORM(context, claimId) {
            try {
                let query = await axios.get(`/claims/${claimId}`);
                if (query.data.status == "error") {
                    throw new Error(error);
                }
                context.commit("ADD_DATA_TO_STATE", query.data.data);
                return query;
            } catch (error) {
                throw new Error(error);
            }
        },

        async SAVE_FORM(context, data) {
            let dataToSend = data.dataToSend;
            let claimId = data.claimId;
            try {
                let query = await axios.post(
                    `/claims/${claimId}/additional-info`,
                    dataToSend
                );
                if (query.data.status == "error") {
                    throw new Error(error);
                }
                // context.commit("ADD_ADDITIONAL_INFO_TO_STATE", dataToSend);
                context.dispatch("POPULATE_FORM", claimId);
                return query;
            } catch (error) {
                throw new Error(error);
            }
        },
    },
};

export default secondForm;
